<div class="flex-control flex-column flex-height">
  <app-tabs>
    <li
      (click)="tabs_service.deactivate_tab()"
      [class.active]="!tabs_service.is_active()">
      <i class="fa fa-envelope-o mr-sm"></i>
      Secure Messaging
    </li>
  </app-tabs>

  <div
    class="updox-layout"
    [class.message-detail-open]="isMessageDetailOpen"
    [hidden]="tabs_service.is_active()">

    <!-- Column 1: Folder list -->
    <div class="updox-folder-col flex-height scroll-browser">
      <app-updox-folder-list
        [activeView]="activeView"
        [userAddress]="updoxUserAddress"
        [counts]="folderCountsView"
        (folderSelected)="onFolderSelected($event)"
        (newMessage)="openCompose()">
      </app-updox-folder-list>
    </div>

    <!-- Column 2: Message list -->
    <div
      class="updox-message-col flex-height scroll-browser"
      *ngIf="!isContactsView">

      <app-updox-message-list
        [folder]="activeFolder"
        [practiceId]="practiceId"
        [reloadTrigger]="triggerFolderReload"
        [selectedMessage]="selectedMessage"
        (messageSelected)="onMessageSelected($event)"
        (countsChanged)="onCountsChanged($event)">
      </app-updox-message-list>
    </div>

    <!-- Column 3: Contacts or message detail -->
    <div class="updox-detail-col flex-height">
      <app-updox-contacts
        *ngIf="isContactsView"
        class="updox-detail-scroll"
        [practiceId]="practiceId"
        (composeToContact)="openComposeForContact($event)">
      </app-updox-contacts>

      <ng-container *ngIf="!isContactsView">
        <div
          class="updox-detail-header mobile-view"
          *ngIf="selectedMessage">

          <button
            type="button"
            class="updox-detail-back-button"
            (click)="closeMessageDetail()"
            aria-label="Back to messages">

            <i class="fa fa-arrow-left"></i>
          </button>

          <div class="updox-detail-title">
            <div class="fw-600 fs16">
              Message Details
            </div>
          </div>
        </div>

        <div
          class="updox-detail-body"
          *ngIf="selectedMessage">

          <app-updox-message-detail
            [message]="selectedMessage"
            (reply)="openReply($event)"
            (editDraft)="onEditDraft($event)"
            (deleted)="onMessageDeleted($event)">
          </app-updox-message-detail>
        </div>
<!-- Empty state -->
<div class="updox-detail-empty">
  <i class="fa fa-envelope-o fs40 d-block mb"></i>
  <p class="m0">Select a message to read</p>
</div>

      </ng-container>
    </div>
  </div>

  <!-- Compose tray -->
  <div class="updox-compose-tray">
    <app-updox-compose
      *ngFor="let draft of composeDrafts"
      [draft]="draft"
      [practiceId]="practiceId"
      (close)="closeCompose(draft.localId)"
      (sent)="onMessageSent($event)"
      (savedAsDraft)="onDraftSaved($event)">
    </app-updox-compose>
  </div>
</div>